export const getClientCompanySingleLegalCorporationId = (legalCorporationId: string) => {
  const legalCorporationIds = legalCorporationId.split(',');
  return legalCorporationIds.sort()[0];
};

export const invoiceDateParam = 'invDt';
export const invoiceUpdatedFromParam = 'invFrom';
export const invoiceUpdatedToParam = 'invTo';
export const invoiceIdParam = 'invoiceId';

export const getPermissionId = () => {
  return getParameter('pId');
};

export const getClientCompanyId = () => {
  return getParameter('ccId');
};

export const getInvoiceId = () => {
  return getParameter(invoiceIdParam);
};

export const getInvoiceUpdatedDate = () => {
  return getParameter(invoiceDateParam);
};

/**
 * Invoice filters from a summary notification link: the exact period (invFrom/invTo, unix timestamps)
 * when present, otherwise the single day (invDt)
 */
export const getInvoiceUpdatedFilters = () => {
  const invoiceUpdatedFrom = getParameter(invoiceUpdatedFromParam);
  const invoiceUpdatedTo = getParameter(invoiceUpdatedToParam);
  if (invoiceUpdatedFrom && invoiceUpdatedTo) {
    return { invoiceUpdatedDate: '', invoiceUpdatedFrom, invoiceUpdatedTo };
  }
  return {
    invoiceUpdatedDate: getInvoiceUpdatedDate(),
    invoiceUpdatedFrom: '',
    invoiceUpdatedTo: '',
  };
};

const getParameter = (param: string) => {
  return new URLSearchParams(window.location.search).get(param) || '';
};

export const getAllParameter = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search));
};

export const getTransactionId = () => {
  return getParameter('trn_id');
};

export const getLinkId = () => {
  return getParameter('link_id');
};

export const getTransITTransactionId = () => {
  return getParameter('TransactionID');
};

export const getTransITCustomerReference = () => {
  return getParameter('CustomerRefNumber');
};

export const getTransITErrorMessage = () => {
  return getParameter('ErrorMessage');
};
